/*
 * Copyright (C) 2021 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    inject
} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {LogFactory} from '@utils/log';

const LOG = LogFactory.createLog('SavingInfo');

@Component({
    selector: 'dv-saving-info',
    templateUrl: './saving-info.component.html',
    styleUrls: ['./saving-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SavingInfoComponent implements OnInit {
    private readonly ref = inject(ChangeDetectorRef);

    private static readonly HIDE_SAVED_AFTER_MS = 3000;

    @Input() private readonly saving$: Observable<boolean>;
    public showSaving: boolean;
    public showSaved: boolean;
    private subscription: Subscription;

    public ngOnInit(): void {
        this.subscription = this.saving$.subscribe({
            next: saving => {
                if (saving) {
                    this.showSavingInfo();
                } else {
                    this.hideSavingInfo();
                }
                this.ref.markForCheck();
            },
            error: error => LOG.error(error)
        });
    }

    private showSavingInfo(): void {
        this.showSaving = true;
    }

    private hideSavingInfo(): void {
        this.showSaving = false;
        this.showSaved = true;
        setTimeout(() => {
            this.showSaved = false;
            this.ref.markForCheck();
        }, SavingInfoComponent.HIDE_SAVED_AFTER_MS);
    }
}
